import React from "react"
import { CustomState, CustomStateType, OrderCustomState } from "lib/types/generated/graphql-types"
import { formatOperation } from "../helpers"
import { ReactComponent as BanIcon } from "images/icons/ban.svg"
import { ReactComponent as XMarkCircle } from "images/icons/circle-xmark.svg"

import {
  BannerContainer,
  BannerContent,
  BannerHint,
  BannerTitle,
  BlockedList,
  BlockedOperation,
  StateDescription
} from "./BlockedOperationsBanner.styled"

type Props = {
  orderCustomStates: OrderCustomState[]
  getCustomState: (id: string) => CustomState | undefined
}

const BlockedOperationsBanner = ({ orderCustomStates, getCustomState }: Props) => {
  const blockingStates = orderCustomStates.filter((s) => s.type === CustomStateType.Blocking)

  if (blockingStates.length === 0) return null

  const blockedOperations = [
    ...new Set(blockingStates.flatMap((s) => s.operations ?? []).filter(Boolean))
  ]

  const stateDescriptions = blockingStates
    .map((s) => getCustomState(s.id)?.description ?? s.id)
    .filter(Boolean)

  return (
    <BannerContainer data-testid="blocked-operations-banner">
      <BanIcon />
      <BannerContent>
        <BannerTitle>
          Operations blocked by custom state:{" "}
          {stateDescriptions.map((desc, i) => (
            <StateDescription key={i}>
              {desc}
              {i < stateDescriptions.length - 1 ? ", " : ""}
            </StateDescription>
          ))}
        </BannerTitle>
        {blockedOperations.length > 0 && (
          <>
            <BannerHint>
              Below operations are blocked until the custom state has been removed
            </BannerHint>
            <BlockedList>
            {blockedOperations.map((op) => (
              <BlockedOperation key={op}>
                <XMarkCircle />
                {formatOperation(op)}
              </BlockedOperation>
            ))}
            </BlockedList>
          </>
        )}
      </BannerContent>
    </BannerContainer>
  )
}

export default BlockedOperationsBanner
